import React, { useState, useRef, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import leftArrow from '../../ASUPhotos/icons/me3_carousel_LeftArrow.svg';
import rightArrow from '../../ASUPhotos/icons/me3_carousel_RightArrow.svg';

function Carousel(props) {
  const {
    carouselMedia,
    parent,
    overRideStyles,
    isMobile,
    isTablet,
    numDots,
    showDots,
  } = {
    ...props,
  };

  const [currentDot, setCurrentDot] = useState(0);
  const [carouselDots, setCarouselDots] = useState([]);
  const carouselRef = useRef();

  useEffect(() => {
    const tempDotsArray = [];
    for (let index = 1; index <= numDots; index++) tempDotsArray.push(index);
    setCarouselDots(tempDotsArray);
  }, [numDots]);

  // To use custom controls we need these
  const slideTo = (i) => carouselRef.current.slideTo(i);
  const slideNext = () => carouselRef.current.slideNext();
  const slidePrev = () => carouselRef.current.slidePrev();

  const renderDots = () => {
    const dotsMap = carouselDots.map((dot, index) => {
      return (
        <div
          key={dot}
          className="carousel-dot"
          onClick={() => slideTo(index)}
          onKeyDown={() => slideTo(index)}
          style={{
            backgroundColor: currentDot === index ? props.tenant.primary : null,
          }}
          role="presentation"
        />
      );
    });
    return (
      <div className={['carousel-dot-container', props.parent].join(' ')}>
        {dotsMap}
      </div>
    );
  };

  const handleOnSlideChange = (e) => {
    setCurrentDot(e.item);
  };

  const getPaddingLeft = () => {
    if (!isMobile && isTablet) return 5;
    if (!isMobile && !isTablet) return 5;
    return 0;
  };

  const shouldHideCarousel = () => {
    if (
      props.numTiles < 3 ||
      (props.numTiles <= 3 && (props.isMobile || props.isTablet)) ||
      (props.numTiles <= 5 && !props.isMobile && !props.isTablet)
    )
      return true;
    return false;
  };

  return (
    <div id={`${parent}-carousel-parent`}>
      <div id="vignette" />
      <AliceCarousel
        ref={carouselRef}
        autoPlay={false}
        className={['carousel-component', overRideStyles].join(' ')}
        autoPlayInterval="2000"
        buttonsDisabled
        dotsDisabled
        disableAutoPlayOnAction
        disableDotsControls={isMobile}
        mouseTracking
        animationDuration={400}
        infinite
        onSlideChanged={handleOnSlideChange}
        slideToIndex={currentDot}
        paddingLeft={getPaddingLeft()}
      >
        {carouselMedia.map((group) => (
          // Should we show a card before/after in mobile?
          <div
            className={['carousel-group', overRideStyles].join(' ')}
            key={group.key}
          >
            {group.children}
          </div>
        ))}
      </AliceCarousel>
      <div
        className="top-25-careers-custom-slider-controls"
        style={shouldHideCarousel() ? { display: 'none' } : null}
      >
        {showDots && renderDots()}
        <img
          className="custom-arrows left"
          alt="Button. Click here to change display of top 25 careers above. Move backward."
          src={leftArrow}
          tabIndex={0}
          onClick={() => slidePrev()}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) slidePrev();
          }}
          role="button"
        />
        <img
          className="custom-arrows right"
          alt="Button. Click here to change display of top 25 careers above. Move forward"
          src={rightArrow}
          tabIndex={0}
          onClick={() => slideNext()}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) slideNext();
          }}
          role="button"
        />
      </div>
    </div>
  );
}

export default Carousel;
